import { render, staticRenderFns } from "./検査１.vue?vue&type=template&id=35f886ca&scoped=true&"
import script from "./検査１.vue?vue&type=script&lang=js&"
export * from "./検査１.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f886ca",
  null
  
)

export default component.exports